@if (projects().length > 0) {
  <div class="project-other-cards">
    <div class="project-other-cards__header">
      <span>{{ 'fund.other_projects.title' | translateLang }}</span>
    </div>
    @for (project of projects(); track project.uuid; let last = $last) {
      <div class="project-other-cards__row" (click)="onProjectClick(project.uuid)">
        <img
          class="project-other-cards__thumbnail"
          [src]="project.backgroundImage || placeholder"
          alt="Project thumbnail" />
        <div class="project-other-cards__info">
          <span class="project-other-cards__name">{{ project.name }}</span>
          @if (project.description) {
            <span class="project-other-cards__description">{{ project.description }}</span>
          }
        </div>
        <div class="project-other-cards__actions">
          <div class="project-other-cards__status project-other-cards__status--{{ project.status | lowercase }}">
            <p>{{ project.status | lowercase }}</p>
          </div>
          <div class="project-other-cards__arrow">
            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L6 6L1 11" stroke="#71717b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
      @if (!last) {
        <div class="project-other-cards__divider"></div>
      }
    }
  </div>
}
